import {EventEmitter, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SmartwidgetEventsService {

  public triggerTeaserEvent: EventEmitter<{
    message: string,
    isPredefined: boolean,
  }> = new EventEmitter();

  constructor() {
  }
}
